
// import { http } from '../core';
import http from '../core/utils/request'
import Config from "../app.config";
import {setSidebarMenu} from '../core'

const RequestServiceUser = http.create({ baseURL: Config.ssoServiceUser });
const RequestSsoService = http.create({ baseURL: Config.ssoService });
const RequestService = http.create({ baseURL: Config.roleUrl });
const RequestAuth=http.create({baseURL:Config.AuthUrl})

const RequestJurisdiction = http.create({ baseURL: Config.manageUrl })
const RequestbaseUrl = http.create({ baseURL: Config.BASE_API })
export default {
    getVcode(params){
        // return RequestbaseUrl.post("usercenter/sso/operator/www/v1/user/wechat/sendcaptcha", params);
        return RequestSsoService.post("usercenter/sso/v1/user/wechat/sendcaptcha", params);
    },
    logined(params) {
        return RequestService.get('authority/validate_token', params)
    },
    // 获取密钥
    getEncrypt(params) {
        return RequestSsoService.post('usercenter/user/key_iv', params)
    },
    // 获取密钥---旧
    getThirdEncrypt(params) {
        return RequestServiceUser.post('user/key_iv', params)
    },
    login (params,vm) { // 登录接口
        return RequestServiceUser.post( 'user/login', params ).then((data) => {
            window.localStorage.setItem('wedof_itsm_web_token', data.token);
            window.localStorage.setItem('wedof_itsm_web_user_name', data.cookie.user_name);
            // window.localStorage.setItem('userRole',data.userRole)
            RequestbaseUrl.get('usercenter/sso/operator/www/v2/user/info').then(res => {

                for (let i in res) {
                    window.localStorage.setItem(i, res[i]);
                }
            }, () => {
                return false
            })
            return Promise.resolve(data);
        })
    },
    setUserInfo(params){
        return RequestbaseUrl.get('usercenter/sso/operator/www/v2/user/info')
    },
    UserRoles (params) { // 获取权限
        // return RequestService.get('sys/menu/getMenuByUserName', params, function (result) {
        return RequestAuth.get('menu/get_menu',params).then(result=>{
            let rdata = result;
            setSidebarMenu(rdata.menu_data)
            if (rdata.menu_data.length != 0) {
                let data={...rdata.menu_data}
                let params=[
                    {
                        path: "/login",
                        name: "login",
                        component: "/login/Login"
                    },
                    {
                        path: "/",
                        component: "/Home",
                        // redirect: "/index",
                        children: []
                    },
                    { path: "*", redirect: "/" }
                ];
                params[1].children=rdata.route_data
                data=params
                // console.log(data);
                window.localStorage.setItem('wedof-itsm__router',JSON.stringify(data))

                let userRole = {};
                let roleArr = rdata.permissions;
                roleArr.forEach(function (item) {
                    userRole[item] = 1;
                });
                // console.log(userRole,'允许的按钮权限码');
                return Promise.resolve(userRole);
            } else {
                rdata.message = rdata.message || rdata.msg || '服务器错误';
                return Promise.reject(rdata);
            }
        })
    },
    logout: function () {  // 登出
        return RequestServiceUser.post('user/logout');
    },
    userInfo: function() {
        return RequestSsoService.get('wechat/v1/userinfo')
    },
    //在这里动态获取目录试试
    // getSideBarMenu:function () {

    // }
};
